/* eslint-disable*/

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, Row, Col } from 'antd';
import 'antd/dist/antd.css';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import styles from './POILegend.module.scss';
import lagescoresColorsIntensity from '../../../../utils/lagescores-colors';
import {
  poiLegendText,
  poiLegendTextMappings,
} from '../../../../utils/poiLegendText';
import useWindowDimensions from '../../../../utils/hooks/useWindowDimensions';
import { TestID } from 'utils/testId';

const POILegend = ({ selectedOption }) => {
  const { height, width } = useWindowDimensions();
  const [show, setShow] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [text, setText] = useState();
  const [iconText, setIconText] = useState();
  const [colorValues, setColorValues] = useState();

  const selectColorRangeAndText = (option) => {
    setText(poiLegendText[option]);
    setIconText(poiLegendTextMappings[option]);
    setColorValues(lagescoresColorsIntensity[option]);
  };
  useEffect(() => {
    selectColorRangeAndText(selectedOption);
  }, [selectedOption]);
  return (
    <>
      {
        <div
          data-testid={TestID.POILegend}
          className={styles.legend}
          style={{
            display: show ? '' : 'none',
            height:
              height <= 1000 && width <= 500 && height != null && width != null
                ? '40%'
                : '58%',
            width:
              height <= 1000 && width <= 500 && height != null && width != null
                ? '87%'
                : '59%',
            overflowY: 'auto',
          }}
        >
          <Row span={14}>
            <Col flex={13}>
              <h4 className={styles.h4}>{selectedOption} enthalten sind</h4>
            </Col>
            <Col flex={1}>
              <Button
                type="text"
                icon={<EyeInvisibleOutlined />}
                size="large"
                onClick={() => {
                  setShow((v) => !v);
                }}
              />
            </Col>
          </Row>
          {text &&
            text.map((element, index) => {
              const path = `/assets/img/poiIcons/${iconText[index]}.png`;
              return (
                <div key={element} style={{ marginBottom: '8px' }}>
                  <img src={path} width="20" height="20" float="left" /> &nbsp;
                  &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;&nbsp;
                  {element}
                </div>
              );
            })}
        </div>
      }
      {selectedOption !== 'Wohnlage' && (
        <div
          className={styles.Button}
          onClick={() => setShow((v) => !v)}
          onKeyDown={(e) => e.key === 'Enter' && setShow((v) => !v)}
          role="button"
          tabIndex={0}
          style={{ display: show ? 'none' : 'block' }}
        >
          POI-Legende anzeigen
        </div>
      )}
    </>
  );
};
POILegend.propTypes = {
  selectedOption: PropTypes.string,
};

POILegend.defaultProps = {
  selectedOption: 'Wohnlage',
};
export default POILegend;
